module.exports = __webpack_public_path__ + "static/img/yingrenSkill.8dd1547.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yingrenSkill.png
// module id = r1WL
// module chunks = 0